import Box from 'assets/components/box/Box';
import Button from 'assets/components/button/Button';
import ThemeButtonCircle from 'assets/components/button/themes/Theme.Button.Circle';
import DataMap from 'assets/components/dataMap/DataMap';
import Icon from 'assets/components/icon/Icon';
import Page from 'assets/components/page/Page';
import ThemePageError from 'assets/components/page/themes/Theme.Page.Error';
import ThemeTableSimple from 'assets/components/table/themes/Theme.Table.Simple';
import { getLocales } from 'assets/locales/Locale';
import { useAuthStore } from 'assets/providers/authStore/Provider.AuthStore';
import ThemeWrapperStack from 'assets/themes/wrappers/Theme.Wrapper.Stack';
import { PayeeAction, usePayeeProvider } from '../Payee.Hooks';

export default function PayeeList() {
  const { lang } = getLocales();
  const { listApi, pageRouter } = usePayeeProvider();
  const { permissions } = useAuthStore();

  return !listApi.payload && !listApi.isExecuting && listApi.apiCounter > 0 ? (
    <Page
      class={ThemePageError}
      sidebar={<Icon class="fas-clipboard-list" />}
      header={lang.payees}
      render={lang.noInfo}
    />
  ) : (
    <table className={ThemeTableSimple} data-loading={listApi.isExecuting ? true : undefined}>
      <thead>
        <tr>
          <th>{lang.name}</th>
          <th>{lang.payeeType}</th>
          <th>{lang.address}</th>
          <th data-actions>{lang.actions}</th>
        </tr>
      </thead>
      <tbody>
        <DataMap
          data={listApi.payload?.data}
          render={({ data: payee }) => (
            <tr key={payee.id}>
              <td>
                <b>{payee.name}</b>
              </td>
              <td>{payee.payeeType?.name}</td>
              <td>{payee.fullAddress}</td>
              <td>
                <Box class={ThemeWrapperStack}>
                  <Button
                    onClick={pageRouter.updateParams}
                    data={{
                      id: payee.id.toString(),
                      action: PayeeAction.EDIT,
                    }}
                    disabled={!permissions.EDIT_LOSSCODE}
                    active
                    class={ThemeButtonCircle}
                    htmlElementProps={{
                      title: lang.edit,
                    }}
                    media={<Icon class="fas-edit" />}
                  />
                  <Button
                    onClick={pageRouter.updateParams}
                    data={{
                      id: payee.id.toString(),
                      action: PayeeAction.DELETE,
                    }}
                    disabled={!permissions.DELETE_LOSSCODE}
                    active
                    class={ThemeButtonCircle}
                    htmlElementProps={{
                      title: lang.delete,
                    }}
                    media={<Icon class="fas-trash" />}
                  />
                </Box>
              </td>
            </tr>
          )}
        />
      </tbody>
    </table>
  );
}
